import React from 'react';
import PropTypes from 'prop-types';
import { graphql, StaticQuery } from 'gatsby';
import { Image } from 'components';
import LazyLoad from 'react-lazyload';
import './Rating.scss';

const Rating = ({ rate, red }) => {
  const rating = parseFloat(rate.replace(',', '.').replace(' ', ''));
  const stars = rating * 16 + Math.floor(rating) * 5 + 0.5; // 16% = single star width; 5% = margin between stars; 0.5 is pixel calibration

  return (
    <StaticQuery
      query={graphql`
        query {
          StarsEmpty: file(relativePath: { eq: "logos/empty-stars.png" }) {
            childImageSharp {
              fluid(maxWidth: 220) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
          StarsFull: file(relativePath: { eq: "logos/full-stars.png" }) {
            childImageSharp {
              fluid(maxWidth: 220) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      `}
      render={data => (
        <div className={`rating ${red && 'rating--red'}`}>
          <LazyLoad once offset={200} height={30}>
            <Image
              src={data.StarsEmpty.childImageSharp.fluid}
              alt={'Rating scale'}
              additionalClass={'rating--empty'}
            />
          </LazyLoad>
          <div className={'rating__container'} style={{ width: `${stars}%` }}>
            <LazyLoad once offset={200} height={30}>
              <Image
                src={data.StarsFull.childImageSharp.fluid}
                alt={'Rating'}
                additionalClass={'rating--full'}
              />
            </LazyLoad>
          </div>
        </div>
      )}
    />
  );
};

Rating.defaultProps = {
  rate: '0.0',
  red: false,
};

Rating.propTypes = {
  rate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  red: PropTypes.bool,
};

export default Rating;
